var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CC0000;}\r\n\t.st1{fill:#CC0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ruby_on_rails"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102,58v4.5h8.3c2.6,0,4.7-2.1,4.7-4.7v-1.8c0-2.6-2.1-4.7-4.6-4.7c0,0,0,0-0.1,0h-4.1v-2.1h8.2v-4.6h-7.8 c-2.6,0-4.7,2.2-4.7,4.8v1.6c0,2.6,2.1,4.7,4.7,4.7c5.7,0-1.4,0,3.9,0V58 M57.8,56.9c0,0,4.4-0.4,4.4-6.1c0.1-3.2-2.2-5.9-5.4-6.2 h-9.6v18h4.8v-4.3l4.2,4.3h7.2L57.8,56.9z M55.9,53.2h-3.9v-4.1h3.9c0.8,0.4,1.2,1.2,1.1,2C57.1,52,56.7,52.8,55.9,53.2z  M74.2,44.7h-4.9c-2.6,0-4.7,2.1-4.7,4.7v13.2h4.9v-3.2h4.6v3.2h4.8V49.4C78.9,45.6,75.4,44.7,74.2,44.7z M74.1,54.3h-4.6v-4.4 c0,0,0-1,1.5-1h1.7c1.4,0,1.4,1,1.4,1V54.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.1,
    y: 44.7,
    className: "st1",
    width: 5.1,
    height: 17.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "93.5,58 93.5,44.7 88.4,44.7 88.4,58 88.4,62.6 93.5,62.6 100.4,62.6 100.4,58  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,62.6h20c0,0-3.8-17.4,8.8-24.5c2.7-1.3,11.5-6.4,25.9,4.3c0.5-0.4,0.9-0.7,0.9-0.7S59.2,28.6,44.5,30.1 c-7.3,0.7-16.4,7.3-21.7,16.2C19.7,51.2,17.7,56.8,16.8,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,62.6h20c0,0-3.8-17.4,8.8-24.5c2.7-1.3,11.5-6.4,25.9,4.3c0.5-0.4,0.9-0.7,0.9-0.7S59.2,28.6,44.5,30.1 c-7.3,0.7-16.4,7.3-21.7,16.2C19.7,51.2,17.7,56.8,16.8,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,62.6h20c0,0-3.8-17.4,8.8-24.5c2.7-1.3,11.5-6.4,25.9,4.3c0.5-0.4,0.9-0.7,0.9-0.7S59.2,28.6,44.5,30.1 c-7.4,0.7-16.4,7.3-21.7,16.2S16.8,62.6,16.8,62.6z M58.3,31.5l0.1-1.7c-0.8-0.4-1.6-0.7-2.5-0.9l-0.1,1.7 C56.7,30.9,57.5,31.2,58.3,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,36.8l-0.1,1.6c0.8,0,1.7,0.1,2.5,0.3l0.1-1.6C57.6,37,56.7,36.9,55.9,36.8z M46.6,29h0.2l-0.5-1.5 c-0.8,0-1.6,0.1-2.4,0.2l0.5,1.5C45.1,29,45.9,29,46.6,29z M47.8,38.3l0.6,1.7c0.7-0.4,1.4-0.7,2.2-0.9L50,37.4 C49.3,37.6,48.5,37.9,47.8,38.3z M36.3,31.6l-1.1-1.7c-0.6,0.3-1.3,0.7-2,1.1l1.2,1.8C35.1,32.3,35.7,32,36.3,31.6z M41.5,43 l1.2,1.8c0.4-0.6,0.9-1.3,1.5-1.8l-1.1-1.7C42.5,41.8,42,42.4,41.5,43z M37.9,51.1l2,1.6c0.1-1,0.3-2,0.5-3l-1.8-1.4 C38.3,49.2,38.1,50.2,37.9,51.1L37.9,51.1z M26.8,39.1L25,37.5c-0.7,0.6-1.3,1.3-1.9,1.9l1.9,1.7C25.6,40.4,26.2,39.7,26.8,39.1z  M19.2,50.4l-2.9-1.1c-0.5,1.1-1,2.3-1.3,3l2.9,1.1C18.2,52.6,18.8,51.3,19.2,50.4z M37.5,57.5c0,1.1,0.1,2.1,0.3,3.2l3,1.1 c-0.2-1-0.5-2.1-0.6-3.3L37.5,57.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRails);
export default __webpack_public_path__ + "static/media/Rails.eadf5c59af3223ae2e13f60a11e755f9.svg";
export { ForwardRef as ReactComponent };